import { EnvConfig } from "src/models/env";

const env = process.env.NEXT_PUBLIC_ENV;

console.log(`env: ${env}`);

// Global-E storefront integration — host는 환경별 분리, MID는 단일.
// 정책: docs/global-e-storefront.md §1.2
export const GLOBAL_E_INT_HOST = "intgepi.bglobale.com";
export const GLOBAL_E_PROD_HOST = "gepi.global-e.com";
const GLOBAL_E_MERCHANT_ID =
  process.env.NEXT_PUBLIC_GLOBAL_E_MERCHANT_ID ?? "30001127";

const local: EnvConfig = {
  FacebookPixelId: "1169187264829173",
  BhapticsDevUrl: "https://dev-developer.bhaptics.com/sdk",
  // dev 샌드박스 테스트 구매 계정은 docs/payments/paypal.md 참조.
  // 자격증명 값은 소스·문서에 두지 않는다 (docs/payments/accounts.md).
  PayPalClientId:
    "AVZPazqedysOrR_dEpCcuCdXkXQmURgF7wsDgpEN4ag1awaCeEWBtQ51uaPFGvd1kusWUg7Pwz96CgOj",
  PaypalApiHost: "https://api-m.sandbox.paypal.com",
  Eximbay: {
    MID: "1849705C64",
    ApiHost: "https://api-test.eximbay.com",
  },
  NaverPay: {
    ButtonKey:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_KEY ??
      "DE8C18D2-801A-4E6D-9079-600BC9B6B1B5",
    MerchantNo:
      process.env.NEXT_PUBLIC_NAVERPAY_MERCHANT_NO ?? "np_ezwqm850684",
    CertiKey: process.env.NAVERPAY_CERTI_KEY ?? "",
    ApiHost:
      process.env.NEXT_PUBLIC_NAVERPAY_API_HOST ??
      "https://test-api.pay.naver.com",
    ButtonSdkUrl:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_SDK_URL ??
      "https://test-pay.naver.com/assets/button/latest/npay.button.js",
  },
  GlobalE: {
    MerchantId: GLOBAL_E_MERCHANT_ID,
    Host: process.env.NEXT_PUBLIC_GLOBAL_E_HOST ?? GLOBAL_E_INT_HOST,
  },
};

const development: EnvConfig = {
  FacebookPixelId: "1169187264829173",
  BhapticsDevUrl: "https://dev-developer.bhaptics.com/sdk",
  PayPalClientId:
    "AVZPazqedysOrR_dEpCcuCdXkXQmURgF7wsDgpEN4ag1awaCeEWBtQ51uaPFGvd1kusWUg7Pwz96CgOj",
  PaypalApiHost: "https://api-m.sandbox.paypal.com",
  Eximbay: {
    MID: "1849705C64",
    ApiHost: "https://api-test.eximbay.com",
  },
  NaverPay: {
    ButtonKey:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_KEY ??
      "DE8C18D2-801A-4E6D-9079-600BC9B6B1B5",
    MerchantNo:
      process.env.NEXT_PUBLIC_NAVERPAY_MERCHANT_NO ?? "np_ezwqm850684",
    CertiKey: process.env.NAVERPAY_CERTI_KEY ?? "",
    ApiHost:
      process.env.NEXT_PUBLIC_NAVERPAY_API_HOST ??
      "https://test-api.pay.naver.com",
    ButtonSdkUrl:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_SDK_URL ??
      "https://test-pay.naver.com/assets/button/latest/npay.button.js",
  },
  GlobalE: {
    MerchantId: GLOBAL_E_MERCHANT_ID,
    Host: process.env.NEXT_PUBLIC_GLOBAL_E_HOST ?? GLOBAL_E_INT_HOST,
  },
};

const production: EnvConfig = {
  FacebookPixelId: "563164592039373",
  BhapticsDevUrl: "https://developer.bhaptics.com/sdk",
  // real
  PayPalClientId:
    "AQKTr8_Nbn90OErzVIVj0uKJ7UaowItC6Lx3nxmu4Lhb609cIMRNREXImdQuZmNG_RqTuGjQZRAisdWf",
  PaypalApiHost: "https://api-m.paypal.com",
  Eximbay: {
    MID: "36CB42CAAD",
    ApiHost: "https://api.eximbay.com",
  },
  NaverPay: {
    ButtonKey:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_KEY ??
      "DE8C18D2-801A-4E6D-9079-600BC9B6B1B5",
    MerchantNo:
      process.env.NEXT_PUBLIC_NAVERPAY_MERCHANT_NO ?? "np_ezwqm850684",
    CertiKey: process.env.NAVERPAY_CERTI_KEY ?? "",
    ApiHost:
      process.env.NEXT_PUBLIC_NAVERPAY_API_HOST ??
      "https://test-api.pay.naver.com",
    ButtonSdkUrl:
      process.env.NEXT_PUBLIC_NAVERPAY_BUTTON_SDK_URL ??
      "https://test-pay.naver.com/assets/button/latest/npay.button.js",
  },
  GlobalE: {
    MerchantId: GLOBAL_E_MERCHANT_ID,
    Host: process.env.NEXT_PUBLIC_GLOBAL_E_HOST ?? GLOBAL_E_PROD_HOST,
  },
};

export const isProd = env === "production";
export const isTest = !isProd;
export const isLocal = process.env.NODE_ENV === "development";

export const Env: EnvConfig =
  env === "local" ? local : isProd ? production : development;
